import { SalesChannelStockThresholdListPage } from "@/features/sales-channel-stock-threshold/pages/SalesChannelStockThresholdListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/sales-channel-stock-threshold/")({
	beforeLoad({ context }) {
		if (!context.authAdapter.can({ permissions: ["masterdata.lookup"] })) {
			throw redirect({ to: "/403" });
		}
	},
	component: SalesChannelStockThresholdListPage,
});
